import { Provider } from "react-redux";
import "./App.css";

import store from "./store/store";

import RouterFile from "./RouterFile";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./store/queryClient";
import { useEffect, useState } from "react";
import { AppThemeProvider } from "./theme/AppTheme";

function App() {
  const [theme, setTheme] = useState(() => {
    // Read from localStorage on mount, or default to light
    if (typeof window !== "undefined") {
      const stored = localStorage.getItem("theme");
      if (stored === "dark" || stored === "light") {
        return stored;
      }
      // Check system preference
      if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
        return "dark";
      }
    }
    return "light";
  });

  useEffect(() => {
    if (theme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
    localStorage.setItem("theme", theme);
  }, [theme]);

  // ConfigProvider now lives inside AppThemeProvider, which needs the redux
  // store (for the store id) and the query client (to load the saved preset),
  // so antd is themed from the store's chosen preset rather than a fixed token
  // set.
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <AppThemeProvider>
          <RouterFile setTheme={setTheme} theme={theme} />
        </AppThemeProvider>
      </QueryClientProvider>
    </Provider>
  );
}

export default App;
